import classNames from 'classnames'
import type { FC } from 'react'
import React, { forwardRef, useMemo } from 'react'

import { RadioGroupProvider } from './radio-group-context'
import type { RadioGroupComponents, RadioGroupProps } from './types'
import { useRadioGroup } from './use-radio-group'
import { formikField } from '../_adaptors'
import Box from '../_primitives/box/box'

/**
 * Used for multiple radios which are bound in one group,
 * and it indicates which option is selected.
 *
 */
const RadioGroupPrivate: FC<RadioGroupProps> = forwardRef<
  HTMLDivElement,
  RadioGroupProps
>(function RadioGroupPrivate(props, ref) {
  const { size, variant, children, className, canDeselect, ...rest } = props

  const { value, onChange, getRootProps, name, htmlProps } = useRadioGroup(rest)

  const group = useMemo(
    () => ({
      name,
      size,
      onChange,
      canDeselect,
      value,
      variant
    }),
    [size, name, onChange, value, variant, canDeselect]
  )

  const groupProps = getRootProps(htmlProps as never, ref)

  return (
    <RadioGroupProvider value={group}>
      <Box
        {...groupProps}
        className={classNames('csg-tui-radio-group', className)}
      >
        {children}
      </Box>
    </RadioGroupProvider>
  )
})

//@ts-ignore
const RadioGroup: FC<RadioGroupProps> & RadioGroupComponents = React.forwardRef<
  HTMLDivElement,
  RadioGroupProps
>(function RadioGroup(props, ref) {
  return <RadioGroupPrivate ref={ref} {...props} />
})

RadioGroup.Formik = formikField(RadioGroup, {
  hasFieldWrapper: true,
  useValue: true
})

export default RadioGroup
